import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { UserDefaultImage } from "../images";
import { BackArrowIcon, LogoutIcon } from "../icon/icon";
import { useDispatch, useSelector } from "react-redux";
import { nameFormatting } from "../helpers/commonFunction";
import { Loader } from "../components";
import { headerChildPages } from "../helpers/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { reqToUserLogout } from "../store/slice/userSlice";

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader, user } = useSelector((state) => state.userReducer);
  const [isOpen, setIsOpen] = useState(false);
  const handleUserLogout = () => {
    setIsOpen(false);
    dispatch(reqToUserLogout({ data: "", dispatch }));
  };

  const handleBackNavigation = () => {
    navigate(-1);
  };

  return (
    <>
      {loader && <Loader />}
      <header className={`tc-navbar ${headerChildPages.includes(location.pathname) ? "tc-navbar-1" : ""}`}>
        {headerChildPages.includes(location.pathname) ? (
          <div className="fog_back_button_navbar">
            <button
              type="button"
              className="tc-navbar-back-btn me-0"
              onClick={() => handleBackNavigation()}
            >
              {BackArrowIcon}
            </button>
            <p className="tc-navbar-title">
              {location?.state?.title ? location?.state?.title : ""}
            </p>
            <button className="c-pointer"></button>
          </div>
        ) : (
          <div className="tc-navbar-content">
            <span className="tc-navbar-user-name">
              {console.log("user =>>> ",user)}
              {`TCL ${user?.user_role || "ADMIN"} APP`}
            </span>
            <div className="d-flex flex-column gap-2">
              <Dropdown
                show={isOpen}
                onToggle={() => setIsOpen(!isOpen)}
                className="tc-navbar-profile-dropdown ms-auto"
              >
                <Dropdown.Toggle className="tc-navbar-user-profile">
                  {user && nameFormatting(user, "LF")}
                  <img src={UserDefaultImage} alt="userPhoto" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    as="button"
                    className="tc-navbar-profile-logout-item dropdown-item"
                    onClick={() => handleUserLogout("logout")}
                  >
                    <span className="d-flex align-items-center">
                      <span className="me-2">{LogoutIcon}</span>
                      Logout
                    </span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="tc_main_version_wrapper">
                <span className="tc_main_version_content">
                  Test version {process.env.REACT_APP_VERSION}
                </span>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
